import {
  signedFetch
} from "./chunk-2CSC3FHL.js";

// lib/api/groups.ts
import {
  apiUrlEndpointFactory,
  parseJsonResponse
} from "@lune/common/api";
var groupsBase = (version, root) => apiUrlEndpointFactory(version, root, "/auth/groups").endpoint;
var groupsBaseUrlForTesting = groupsBase;
var usersBase = (version, root) => apiUrlEndpointFactory(version, root, "/auth/users").endpoint;
var usersBaseUrlForTesting = usersBase;
var listUsers = async (version, root) => {
  const res = await signedFetch(usersBase(version, root));
  const data = await parseJsonResponse(res);
  return data.items;
};
var listGroups = async (version, root) => {
  const res = await signedFetch(groupsBase(version, root));
  const data = await parseJsonResponse(res);
  return data.items;
};
var createGroup = async (version, root, group) => {
  const res = await signedFetch(groupsBase(version, root), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(group)
  });
  const data = await parseJsonResponse(res);
  return data.item;
};
var removeGroup = async (version, root, id) => {
  await signedFetch(`${groupsBase(version, root)}/${id}`, { method: "DELETE" });
};
var getGroupMembers = async (version, root, id) => {
  const res = await signedFetch(`${groupsBase(version, root)}/${id}/members`);
  const data = await parseJsonResponse(res);
  return data.item;
};
var resolveGroupMembers = async (version, root, groupId) => {
  const res = await signedFetch(
    `${groupsBase(version, root)}/${groupId}/members/resolve`
  );
  const data = await parseJsonResponse(res);
  return data.items;
};
var addMemberGroupToGroup = async (version, root, groupId, memberGroupId) => {
  const res = await signedFetch(
    `${groupsBase(version, root)}/${groupId}/members/groups`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ groupId: memberGroupId })
    }
  );
  const data = await parseJsonResponse(res);
  return data.item;
};
var removeMemberGroupFromGroup = async (version, root, groupId, memberGroupId) => {
  await signedFetch(
    `${groupsBase(version, root)}/${groupId}/members/groups/${memberGroupId}`,
    { method: "DELETE" }
  );
};
var addUserToGroup = async (version, root, groupId, userId) => {
  const res = await signedFetch(
    `${groupsBase(version, root)}/${groupId}/members/users`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ userId })
    }
  );
  const data = await parseJsonResponse(res);
  return data.item;
};
var removeUserFromGroup = async (version, root, groupId, userId) => {
  await signedFetch(
    `${groupsBase(version, root)}/${groupId}/members/users/${userId}`,
    { method: "DELETE" }
  );
};

export {
  groupsBaseUrlForTesting,
  usersBaseUrlForTesting,
  listUsers,
  listGroups,
  createGroup,
  removeGroup,
  getGroupMembers,
  resolveGroupMembers,
  addMemberGroupToGroup,
  removeMemberGroupFromGroup,
  addUserToGroup,
  removeUserFromGroup
};
